import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TAB_INDEX } from '../../pages/Cancerigenos/pages';

type CarcinogenicReportParametricDataItem = {
    id: number;
    descripcion: string;
};
interface CarcinogenicReportParametricData {
    caracteristicasEquipo: CarcinogenicReportParametricDataItem[];
    elementosProteccion: CarcinogenicReportParametricDataItem[];
    examenesMedico: CarcinogenicReportParametricDataItem[];
    medidasPrevencion: CarcinogenicReportParametricDataItem[];
    metodosProcesadoImagen: CarcinogenicReportParametricDataItem[];
    modosEmpleo: CarcinogenicReportParametricDataItem[];
    tiposEstudio: CarcinogenicReportParametricDataItem[];
    tiposEquipo: CarcinogenicReportParametricDataItem[];
    tiposFrecuencia: CarcinogenicReportParametricDataItem[];
    tiposFuente: CarcinogenicReportParametricDataItem[];
    tiposRadiacion: CarcinogenicReportParametricDataItem[];
    tiposResponsableEquipo: CarcinogenicReportParametricDataItem[];
    unidadesMedida: CarcinogenicReportParametricDataItem[];
    usos: CarcinogenicReportParametricDataItem[];
}

interface InitialState {
    selectedCarcinogenicReportId: number | null;
    carcinogenicReport: any;
    currentTab: TAB_INDEX;
    carcinogenicParametricData: CarcinogenicReportParametricData | null;
    selectedWorker: any;
    ciiuCodes: any;
}

const initialState: InitialState = {
    selectedCarcinogenicReportId: null,
    carcinogenicReport: null,
    currentTab: TAB_INDEX.ESTABLISHMENT_DATA,
    carcinogenicParametricData: null,
    selectedWorker: null,
    ciiuCodes: []
};

const carcinogenicReportSlice = createSlice({
    name: 'carcinogenicReport',
    initialState,
    reducers: {
        clearSelectedReportData: (state) => {
            state.selectedCarcinogenicReportId = null;
            state.carcinogenicReport = null;
            state.currentTab = TAB_INDEX.ESTABLISHMENT_DATA;
            state.carcinogenicParametricData = null;
            state.selectedWorker = null
        },
        setSelectedCarcinogenicReportId: (state, action: PayloadAction<number | null>) => {
            state.selectedCarcinogenicReportId = action.payload;
        },
        setCarcinogenicReportData: (state, action: PayloadAction<any>) => {
            state.carcinogenicReport = action.payload;
        },
        setCarcinogenicReportCIIUCodes: (state, action: PayloadAction<any>) => {
            state.ciiuCodes = action.payload;
        },
        setCarcinogenicReportCurrentTab: (state, action: PayloadAction<TAB_INDEX>) => {
            state.currentTab = action.payload;
        },
        setCarcinogenicReporParametricData: (
            state,
            action: PayloadAction<CarcinogenicReportParametricData | null>
        ) => {
            state.carcinogenicParametricData = action.payload;
        },
    }
});

export const {
    clearSelectedReportData,
    setSelectedCarcinogenicReportId,
    setCarcinogenicReportData,
    setCarcinogenicReportCurrentTab,
    setCarcinogenicReporParametricData,
    setCarcinogenicReportCIIUCodes
} = carcinogenicReportSlice.actions;
export default carcinogenicReportSlice.reducer;
